import { TaskStatus, TaskSubjectKind, TaskType } from '../../api/admin';

/** Display labels for the task types. The stored value is the code; rename a label here freely. Order = dropdown order. */
export const TASK_TYPE_OPTIONS: { value: TaskType; label: string }[] = [
	{ value: 'follow_up', label: 'Follow-up' },
	{ value: 'onboarding', label: 'Onboarding' },
	{ value: 'custom_views', label: 'Custom Views' },
	{ value: 'ad_hoc', label: 'Ad Hoc' },
	{ value: 'tech_support', label: 'Tech Support' },
	{ value: 'new_feature', label: 'New Feature' },
	{ value: 'contract', label: 'Contract' },
	{ value: 'vendor', label: 'Vendor' },
	{ value: 'marketing', label: 'Marketing' },
	{ value: 'other', label: 'Other' },
];

export const DEFAULT_TASK_TYPE: TaskType = 'follow_up';

export const TASK_STATUS_OPTIONS: { value: TaskStatus; label: string }[] = [
	{ value: 'open', label: 'Open' },
	{ value: 'in_progress', label: 'In progress' },
	{ value: 'done', label: 'Done' },
];

export const TASK_SUBJECT_KIND_OPTIONS: { value: TaskSubjectKind; label: string }[] = [
	{ value: 'user', label: 'Users' },
	{ value: 'team', label: 'Teams' },
	{ value: 'account', label: 'Accounts' },
];

/** Detail page for each subject kind, for the links in "Tagged to". */
export const SUBJECT_PATH: Record<TaskSubjectKind, string> = {
	user: '/admin/users',
	team: '/admin/teams',
	account: '/admin/accounts',
};

export const taskTypeLabel = (value: string): string => TASK_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value;
export const taskStatusLabel = (value: string): string =>
	TASK_STATUS_OPTIONS.find((o) => o.value === value)?.label ?? value;

export const userLabel = (u: { full_name: string | null; email: string }): string => u.full_name ?? u.email;

/** A fixed, muted colour per type so a glance down the column tells the kinds apart. */
export const TASK_TYPE_COLORS: Record<TaskType, string> = {
	follow_up: '#64b5f6',
	onboarding: '#4db6ac',
	custom_views: '#b39ddb',
	ad_hoc: '#ffd54f',
	tech_support: '#ef9a9a',
	new_feature: '#9fa8da',
	contract: '#bcaaa4',
	vendor: '#80deea',
	marketing: '#f48fb1',
	other: '#b0bec5',
};

export const taskTypeColor = (value: string): string =>
	TASK_TYPE_COLORS[value as TaskType] ?? TASK_TYPE_COLORS.other;

/** Stronger colours than the types, one per admin; the circle shape keeps them apart from the type chips. */
const ASSIGNEE_PALETTE = ['#ffb74d', '#81c784', '#4fc3f7', '#ce93d8', '#ff8a65', '#aed581', '#f06292', '#9575cd'];
const NO_ASSIGNEE_COLOR = '#78909c';

/** The same person always gets the same colour: position in the assignee list ordered by id, so new admins append. */
export function assigneeColor(userId: number | null, assignees: { id: number }[]): string {
	if (userId === null) return NO_ASSIGNEE_COLOR;
	const index = [...assignees].sort((a, b) => a.id - b.id).findIndex((a) => a.id === userId);
	return index === -1 ? NO_ASSIGNEE_COLOR : ASSIGNEE_PALETTE[index % ASSIGNEE_PALETTE.length];
}
